const htmlTemplate = ({ pages, topicTitle, discipline, academicLevel }, index) =>
  `<li class="card">
                <div class="card__container">
                  <div class="card__row">
                    <div class="card__row-item">
                      <div class="card__title">Title:</div>
                      <div class="card__value">${topicTitle}</div>
                    </div>
                  </div>

                  <div class="card__row">
                    <div class="card__row-item">
                      <div class="card__title">Discipline:</div>
                      <div class="card__value card__value--width">${discipline}</div>
                    </div>

                    <div class="card__row-item">
                      <div class="card__title">Pages:</div>
                      <div class="card__value card__value--width">${pages}</div>
                    </div>
                  </div>

                  <div class="card__row">
                    <div class="card__row-item">
                      <div class="card__title">Academic level:</div>
                      <div class="card__value card__value--width">${academicLevel} </div>
                    </div>

                    <div class="card__row-item">
                      <div class="card__title">Delivered:</div>
                      <div class="card__value card__value--width">
                         ${index > 3 ? 'Today' : 'Yesterday'}
                       </div>
                    </div>
                  </div>
                </div>
                <div class="card__decor">
                </div>
   </li>`;

export default htmlTemplate;
